export enum TeamImageSize {
  SM,
  LG
}
export interface TeamImageProps {
  image: string
  size?: TeamImageSize
}
